const SECTION_FIELD_MAP = {
  "Info Generali":     "info_generali",
  "Rinvaso":           "info_rinvaso",
  "Esposizione":       "info_esposizione",
  "Irrigazione":       "info_irrigazione",
  "Manutenzione":      "info_manutenzione",
  "Malattie":          "info_malattie",
  "Curiosità":         "info_curiosita",
  "Per i più esperti": "info_esperti",
};

const SEZIONI_ATTESE = Object.keys(SECTION_FIELD_MAP);

export function parseMd(text, specie_list) {
  const blocks = splitBySpecie(text);
  if (blocks.length === 0) {
    return { global_error: "Nessuna intestazione '# ' valida trovata nel file." };
  }
  return { results: blocks.map((b) => parseBlock(b, specie_list)) };
}

function splitBySpecie(text) {
  const lines = text.split("\n");
  const blocks = [];
  let current = null;
  for (const line of lines) {
    const m = line.match(/^# (?!#)(.+)$/);
    if (m) {
      if (current) blocks.push(current);
      current = { nome: m[1].trim(), lines: [] };
    } else if (current) {
      current.lines.push(line);
    }
  }
  if (current) blocks.push(current);
  return blocks;
}

function parseBlock(block, specie_list) {
  const errors = [];
  const warnings = [];
  const campi = {};
  const seen = new Set();

  let cur_name = null;
  let cur_lines = [];

  const flush = () => {
    if (cur_name === null) return;
    if (seen.has(cur_name)) {
      errors.push(`Sezione duplicata: "${cur_name}"`);
    } else {
      seen.add(cur_name);
      if (SECTION_FIELD_MAP[cur_name]) {
        campi[SECTION_FIELD_MAP[cur_name]] = cur_lines.join("\n").trim();
      } else {
        errors.push(`Nome sezione non riconosciuto: "${cur_name}"`);
      }
    }
  };

  for (const line of block.lines) {
    const m = line.match(/^## (.+)$/);
    if (m) {
      flush();
      cur_name = m[1].trim();
      cur_lines = [];
    } else if (cur_name !== null) {
      cur_lines.push(line);
    }
  }
  flush();

  for (const attesa of SEZIONI_ATTESE) {
    if (!seen.has(attesa)) {
      warnings.push(`Sezione "${attesa}" assente — campo non modificato`);
    }
  }

  const all_text = Object.values(campi).join("\n");
  if ((all_text.match(/\*\*/g) || []).length % 2 !== 0) {
    warnings.push("Possibile **grassetto** non chiuso — verificare la formattazione");
  }

  const nome_norm = block.nome.toLowerCase();
  const exact = specie_list.filter(
    (s) =>
      s.nome.trim().toLowerCase() === nome_norm ||
      (s.nome_sc && s.nome_sc.trim().toLowerCase() === nome_norm)
  );

  let match_status, record_id, candidates;
  if (exact.length === 1) {
    match_status = "found";
    record_id = exact[0].id;
    candidates = [];
  } else if (exact.length > 1) {
    match_status = "ambiguous";
    record_id = null;
    candidates = exact;
  } else {
    match_status = "not_found";
    record_id = null;
    candidates = specie_list
      .filter(
        (s) =>
          s.nome.toLowerCase().includes(nome_norm) ||
          nome_norm.includes(s.nome.toLowerCase())
      )
      .slice(0, 5);
  }

  return { nome_specie: block.nome, match_status, record_id, candidates, campi, warnings, errors };
}
